import {
  GetRolesAndPermissionsContextQuery,
  GetSubTenantRolesAndPermissionsForAdminQuery,
  OriginatorQueryInput,
} from 'src/app/graphql/generated';

export function originatorInputFromId(
  originatorId?: string | null
): OriginatorQueryInput | null {
  const trimmed = originatorId?.trim();
  return trimmed ? { originatorId: trimmed } : null;
}

export function rolesAndPermissionsPayload(
  data:
    | GetRolesAndPermissionsContextQuery
    | GetSubTenantRolesAndPermissionsForAdminQuery
): {
  roles: NonNullable<GetRolesAndPermissionsContextQuery['roles']>;
  permissions: NonNullable<GetRolesAndPermissionsContextQuery['permissions']>;
  isTenantMfaEnabled?: boolean;
  isSsoEnabled?: boolean;
} | null {
  if (!data?.roles && !data?.permissions) {
    return null;
  }

  const tenantContext = data as GetRolesAndPermissionsContextQuery;
  const mfaRequired =
    'tenant' in data ? tenantContext.tenant?.mfaRequired : undefined;
  const isSsoEnabled =
    'tenant' in data ? tenantContext.tenant?.isSsoEnabled : undefined;

  return {
    roles: (data.roles ?? []) as NonNullable<
      GetRolesAndPermissionsContextQuery['roles']
    >,
    permissions: (data.permissions ?? []) as NonNullable<
      GetRolesAndPermissionsContextQuery['permissions']
    >,
    ...(mfaRequired != null ? { isTenantMfaEnabled: !!mfaRequired } : {}),
    ...(isSsoEnabled != null ? { isSsoEnabled: !!isSsoEnabled } : {}),
  };
}
